// @ts-check


// type SubtitleConfig = {
//     transistion: 'none' | 'subtitle-bounce' | 'subtitle-slideup' | 'subtitle-expand-letter-spacing' | 'word-bounce' | 'word-slideup',
//     enableWordReveal: boolean,
//     wordHighlight: 'current-only' | 'upto-current' | 'background' | 'none';
//     subitileCharLimit: number // 0 to 1000
//     enableUppercase: boolean,
//     enableBackgroundBox: boolean,
//     colors: {
//         primaryColor: string,
//         secondaryColor: string,
//         outlineColor: string,
//     },
//     font: {
//         fontName: string,
//         fontWeights: string,
//         fontSize: number,
//         fontStrokeSize: number,
//     },
//     blockVerticalPosition: 'top' | 'middle' | 'bottom',
//     emojiPosition: 'top' | 'bottom',
//     emojis :{ 
//         position: 'top' | 'bottom',
//         fontSize: number,
//         transition: 'none' | 'scale-in' | 'slide-up' | 'slide-down' | 'rotate' | 'fade-in' | 'scale-in-rotate' | 'random'
//     }

// }

// type PlayerConfig = {
//     maxWidth: number,
//     currentTime: number,
//     lineHeight: number,
//     x: number,
//     canvasWidth: number,
//     canvasHeight: number,
//     context: CanvasRenderingContext2D,
//     blockPositionPaddingFactorTop: number,
//     blockPositionPaddingFactorBottom: number,
//     emojiFontStyle: string,
// }


// type TrascriptWord = {
//     start: number,
//     end: number,
//     word: string,
//     isNewBlockStart: boolean,
//     duration: number,
//     color: string,
// }
// type Trascript = TranscriptWord[];

// type CurrentTranscript = {
//     transcriptWords: TranscriptWords[]
// }

// type TranscriptWordLine = TranscriptWord & {
//     width: number,
//     height: number,
//     lineIndex: number,
//     x: number,
//     y: number,
//     offsetLeft: number,
//     offsetTop: number,
// }

// type CurrentTranscriptLine = {
//     transcriptWordsLine: TranscriptWordLine[]
// }

const CONFIGS = {
    WORD_BOX: {
        PADDING: 10,
        RADIUS: 20,
    },
    SUBTITLE_BOX: {
        PADDING: 20,
        RADIUS: 20,
    },
    SUBTITLE_SLIDEUP: {
        MAX_OFFSET: 15,
        TIME_DURATION: 10 * 1 / 30,
    },
    SUBTITLE_BOUNCE: {
        MAX_SCALE: 1,
        MIN_SCALE: .5,
        TIME_DURATION: 10 * 1 / 30,
    },
    WORD_SLIDEUP: {
        MAX_OFFSET: 15,
        TIME_DURATION: 10 * 1 / 30,
    },
    WORD_BOUNCE: {
        MAX_SCALE: 1,
        MIN_SCALE: .5,
        TIME_DURATION: 10 * 1 / 30,
    },
    EMOJI: {
        DEBUG: false,
        TIME_DURATION: 10 * 1 / 30,
        RANDOM_CYCLE_TRANSITION: ['slide-up', 'slide-down', 'scale-in', 'rotate', 'scale-in-rotate', 'fade-in'],
        ROTATE_MAX_DEGREE: 30,
        cycleTransition: function (seed ) {
            const positiveSeed = Math.abs(seed);
            return this.RANDOM_CYCLE_TRANSITION[positiveSeed % this.RANDOM_CYCLE_TRANSITION.length];
        }
    }
}


export class SubtitleRender {
    static GetCurrentTranspcript(subtitleConfig, playerConfig, transcript) {
        const { currentTime } = playerConfig;
        const currentWordIndex = transcript.findIndex(
            (word) =>
                word.start <= currentTime &&
                word.end >= currentTime
        );
        if (currentWordIndex < 0) return null;
        // find complete sentence. New sentese starts with a word that has isNewBlockStart = true
        let start = currentWordIndex;
        let end = currentWordIndex;
        while (start > 0 && !transcript[start].isNewBlockStart)
            start--;
        for (; end < transcript.length;) {
            if (end + 1 < transcript.length && transcript[end + 1].isNewBlockStart)
                break;
            end++;
        }
        let endExcluding = end + 1;

        let currentSentence = transcript.slice(start, endExcluding)

        if (subtitleConfig.enableUppercase) {
            currentSentence = currentSentence.map((wordTranscript) => {
                return {
                    ...wordTranscript,
                    word: wordTranscript.word.toUpperCase(),
                    emojis: wordTranscript.emojis,
                    resetPreviousEmojis: wordTranscript.resetPreviousEmojis,
                }
            })
        }

        return {
            transcriptWords: currentSentence,
            transcriptStart: start,
            transcriptEnd: end,
        }
    }
    static CorrectEmojis(emoji) {
        return emoji;
        // if (typeof emoji === 'string') {
        //     if (emoji.length > 2) {
        //         // console.log(emoji)
        //         // console.log(emoji.substring(0, 2))
        //         return emoji.substring(0, 2);
        //     } else {
        //         return emoji;
        //     }
        // } else {
        //     return undefined;
        // }
    }
    static BreakIntoLines(subtitleConfig, playerConfig, currentTranscript) {
        const words = currentTranscript.transcriptWords.map((word) => word.word);
        const widthOfSpace = playerConfig.context.measureText(" ").width;
        const wordStats = words.map((word, wordIndex) => {
            // check if word is emoji
            // if ([true][0]) {
            //     console.log(word)
            //     // U+1F64B
            //     // console.log(word.match(/[\u{1F600}-\u{1F64F}]/gu))
            // }
            const metrics = playerConfig.context.measureText(word);
            // https://stackoverflow.com/questions/1134586/how-can-you-find-the-height-of-text-on-an-html-canvas
            let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
            let actualWordHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
            // console.log(fontHeight,actualWordHeight)
            const correctedEmojis = SubtitleRender.CorrectEmojis(currentTranscript.transcriptWords[wordIndex].emojis);
            const resetPreviousEmojis = currentTranscript.transcriptWords[wordIndex].resetPreviousEmojis;
            // if (correctedEmojis) {
            //     debugger;
            // }
            return ({
                emojis: correctedEmojis,
                resetPreviousEmojis,
                word: word,
                width: metrics.width,
                height: fontHeight,
                heightBelowBaseline: metrics.fontBoundingBoxDescent,
                heightAboveBaseline: metrics.fontBoundingBoxAscent,
                actualWordHeight: actualWordHeight,
                // actualWordHeightBelowBaseline: metrics.actualBoundingBoxDescent,
                // actualWordHeightAboveBaseline: metrics.actualBoundingBoxAscent,
            });
        });
        // Getting Proper line index for each word
        let lines = [];
        for (let i = 0; i < wordStats.length; i++) {
            let line = []
            let lineWidth = 0;
            while (i < words.length) {
                let nextWordWidth = wordStats[i].width;
                if (line.length == 0) {
                    line.push(words[i]);
                    lineWidth += nextWordWidth;
                    i++;
                } else if (nextWordWidth + lineWidth + widthOfSpace > playerConfig.maxWidth) {
                    i--;
                    break;
                } else {
                    line.push(words[i]);
                    lineWidth += nextWordWidth + widthOfSpace;
                    i++;
                }
            }
            lines.push(line);
        }

        // map lines back to word index for lines
        let lineIndicies = lines.flatMap((line, index) => line.map(() => index));
        const result = {
            transcriptWordsLine: currentTranscript.transcriptWords.map((word, index) => {
                return {
                    ...word,
                    emojis: wordStats[index].emojis,
                    resetPreviousEmojis: wordStats[index].resetPreviousEmojis,
                    x: 0,
                    y: 0,
                    offsetLeft: 0,
                    offsetTop: 0,
                    width: wordStats[index].width,
                    height: wordStats[index].height,
                    heightBelowBaseline: wordStats[index].heightBelowBaseline,
                    heightAboveBaseline: wordStats[index].heightAboveBaseline,
                    actualWordHeight: wordStats[index].actualWordHeight,
                    lineIndex: lineIndicies[index]
                }
            }),
            transcriptStart: currentTranscript.transcriptStart,
            transcriptEnd: currentTranscript.transcriptEnd,
        }

        // correct x and y position of each word
        let x = 0;
        let y = 0;
        let lastLineIndex = 0;
        for (let i = 0; i < result.transcriptWordsLine.length; i++) {
            const word = result.transcriptWordsLine[i];
            if (lastLineIndex != word.lineIndex) {
                x = 0;
                y += playerConfig.lineHeight;
            }
            word.x = x;
            word.y = y;
            x += word.width + widthOfSpace;
            lastLineIndex = word.lineIndex;
        }

        // make lines center aligned
        const maxLineIndex = Math.max(...result.transcriptWordsLine.map((word) => word.lineIndex));
        for (let i = 0; i <= maxLineIndex; i++) {
            let lineWidth = SubtitleRender.getLineWidth(result.transcriptWordsLine, i);
            let leftOffsetToCenter = (playerConfig.maxWidth - lineWidth) / 2;
            result.transcriptWordsLine.filter((word) => word.lineIndex === i).forEach((word) => {
                word.x += leftOffsetToCenter;
            })
        }

        return result;
    }

    // static BreakIntoWords(subtitleConfig,context, text, playerConfig) {
    // }

    static Draw(subtitleConfig, playerConfig, currentTranscriptLines) {
        const { transcriptWordsLine } = currentTranscriptLines;
        let {
            context,
            x: playerX,
            blockPositionPaddingFactorTop,
            blockPositionPaddingFactorBottom,
        } = playerConfig;

        // SubtitleRender.DebugAlignment(playerConfig);

        // Handle colors
        let {
            primaryColor: configPrimaryColor,
            secondaryColor: configSecondaryColor,
            outlineColor: configOutlineColor
        } = subtitleConfig.colors;
        let configBoxColor = 'rgba(0,0,0,0)';
        if (subtitleConfig.enableBackgroundBox) {
            configBoxColor = configOutlineColor
            configOutlineColor = 'rgba(0,0,0,0)';
        }
        // End Handle colors


        const highlightedWordIndex = transcriptWordsLine.findIndex((word) => {
            return word.start <= playerConfig.currentTime && word.end >= playerConfig.currentTime;
        }
        );
        let rect = {
            left: 100000,
            right: 0,
            top: 1000000,
            bottom: 0,
        }
        let shouldShowBackgroundBox = subtitleConfig.enableBackgroundBox && subtitleConfig.wordHighlight !== 'background';
        let isBlockPositionMiddle = subtitleConfig.blockVerticalPosition === 'middle';
        const isBlockPositionTop = subtitleConfig.blockVerticalPosition === 'top';
        const isBlockPositionBottom = subtitleConfig.blockVerticalPosition === 'bottom';
        const isBlockPositionAuto = subtitleConfig.blockVerticalPosition === 'auto';


        if (shouldShowBackgroundBox || isBlockPositionMiddle || isBlockPositionTop || isBlockPositionBottom || isBlockPositionAuto) {
            // calculate the rect only when necessary.
            transcriptWordsLine.forEach((word) => {
                let wLeft = playerX + word.x;
                let wRight = wLeft + word.width;
                let wTop = word.y + word.heightBelowBaseline;
                let wBottom = wTop + word.height;
                rect.left = Math.min(rect.left, wLeft);
                rect.right = Math.max(rect.right, wRight);
                rect.top = Math.min(rect.top, wTop);
                rect.bottom = Math.max(rect.bottom, wBottom);
            })
        }

        if (isBlockPositionTop) {
            let offsetY = playerConfig.canvasHeight * blockPositionPaddingFactorTop - rect.top;
            context.translate(0, offsetY);
        }
        if (isBlockPositionMiddle) {
            let offsetY = (playerConfig.canvasHeight) / 2 - rect.bottom / 2 - rect.top / 2;
            context.translate(0, offsetY);
        }
        if (isBlockPositionBottom) {
            const offsetY = playerConfig.canvasHeight * (1 - blockPositionPaddingFactorBottom) - rect.bottom;
            context.translate(0, offsetY);
        }

        if (shouldShowBackgroundBox) {
            const padding = CONFIGS.SUBTITLE_BOX.PADDING;
            const radius = CONFIGS.SUBTITLE_BOX.RADIUS;
            context.save();
            context.fillStyle = configBoxColor;
            context.beginPath();
            context.roundRect(
                rect.left - padding,
                rect.top - padding,
                rect.right - rect.left + padding * 2,
                rect.bottom - rect.top + padding * 2,
                radius
            );
            context.fill();
            context.restore();
        }



        if (subtitleConfig.transition === 'subtitle-slideup') {
            const firstWord = transcriptWordsLine[0];
            const time = playerConfig.currentTime - firstWord.start;
            let totalDuration = CONFIGS.SUBTITLE_SLIDEUP.TIME_DURATION;
            const maxOffset = CONFIGS.SUBTITLE_SLIDEUP.MAX_OFFSET;
            const minOffset = 0;
            const offset = MathUtil.lerp(maxOffset, minOffset, time / totalDuration, 'linear');
            context.translate(0, offset);
        } else if (subtitleConfig.transition === 'subtitle-bounce') {
            const firstWord = transcriptWordsLine[0];
            const time = playerConfig.currentTime - firstWord.start;
            let totalDuration = CONFIGS.SUBTITLE_BOUNCE.TIME_DURATION;
            const maxScale = CONFIGS.SUBTITLE_BOUNCE.MAX_SCALE;
            const minScale = CONFIGS.SUBTITLE_BOUNCE.MIN_SCALE;
            const scale = MathUtil.lerp(minScale, maxScale, time / totalDuration, 'bounce');
            const currentXY = {
                x: playerX,
                y: 0,
            }
            const totalLines = transcriptWordsLine[transcriptWordsLine.length - 1].lineIndex + 1;
            const totalLineHeight = totalLines * playerConfig.lineHeight;
            // scale from center of the subtitle
            context.translate(currentXY.x + playerConfig.maxWidth / 2, currentXY.y + totalLineHeight / 2);
            context.scale(scale, scale);
            context.translate(-currentXY.x - playerConfig.maxWidth / 2, -currentXY.y - totalLineHeight / 2);
        }

        let groupIndex = 0;
        const emojiGroupByReset = transcriptWordsLine.reduce((acc, word) => {
            if(word.resetPreviousEmojis) {
                groupIndex++;
            }
            acc.push(groupIndex);
            return acc;
        }
        , []);
        const currentHihglightedGroupIndex = emojiGroupByReset[highlightedWordIndex];
        const allEmojis = transcriptWordsLine
            .filter((_,index) => emojiGroupByReset[index] === currentHihglightedGroupIndex)
            .filter((word) => typeof word.emojis === 'string')
            .map((word) => word.emojis)
        const allEmjiText = allEmojis.join(' ');
        context.save();
        context.font = `${subtitleConfig.emojis.fontSize}px ${playerConfig.emojiFontStyle}`;
        const allEmojiMeasure = context.measureText(allEmjiText);
        context.restore();
        const allEmojisLength = allEmojiMeasure.width;
        const allEmojisHeight = allEmojiMeasure.actualBoundingBoxAscent + allEmojiMeasure.actualBoundingBoxDescent;
        let lengthOnCanvas = allEmojisLength;
        const canvasLength = playerConfig.canvasWidth;
        const emojiOffsetX = (canvasLength - lengthOnCanvas) / 2;
        let currentEmojiOffsetX = emojiOffsetX;
        const isEmojiPositionTop = subtitleConfig.emojis.position === 'top';

        for (let i = 0; i < transcriptWordsLine.length; i++) {
            const word = transcriptWordsLine[i];
            const text = word.word;
            const xPosition = playerX + word.x;
            const yPosition = word.y;
            const isBeforeHighlighted = i < highlightedWordIndex;
            const isHighlighted = highlightedWordIndex == i;
            const isLaterThanHighlighted = i > highlightedWordIndex;
            const primaryColor = subtitleConfig.wordHighlight != 'none' && word.color ? word.color : configPrimaryColor;
            const secondaryColor = subtitleConfig.wordHighlight == 'none' && word.color ? word.color : configSecondaryColor;
            const outlineColor = configOutlineColor

            // Render Emojis
            if (typeof word.emojis === 'string' && i <= highlightedWordIndex &&
                emojiGroupByReset[i] === currentHihglightedGroupIndex
            ) {
                context.save();
                context.font = `${subtitleConfig.emojis.fontSize}px ${playerConfig.emojiFontStyle}`;
                let emojiOffsetY = 0;
                const measureEmoji = context.measureText(word.emojis);
                const measureEmojiPlusSpace = context.measureText(word.emojis + ' ');
                if (isEmojiPositionTop) {
                    emojiOffsetY = rect.top - subtitleConfig.emojis.verticalGap - allEmojiMeasure.actualBoundingBoxDescent;
                } else {
                    emojiOffsetY = rect.bottom + subtitleConfig.emojis.verticalGap + allEmojiMeasure.actualBoundingBoxAscent;
                }
                context.translate(currentEmojiOffsetX, emojiOffsetY);
                const emojiRect = {
                        x: 0,
                        y: -measureEmoji.actualBoundingBoxAscent,
                        width: measureEmoji.width,
                        height: measureEmoji.actualBoundingBoxAscent + measureEmoji.actualBoundingBoxDescent
                }
                const others = {
                    allEmojisHeight,
                    emojiWidth: emojiRect.width,
                    emojiHeight: emojiRect.height,
                    emojiCenter: {
                        x: emojiRect.x + emojiRect.width / 2,
                        y: emojiRect.y + emojiRect.height / 2,
                    }
                };
                const time = playerConfig.currentTime - word.start;
                if(time > 0) {
                    const duration = CONFIGS.EMOJI.TIME_DURATION;
                    const transition = subtitleConfig.emojis.transition;
                    let newTransition = transition;
                    if(transition === 'random') {
                        newTransition = CONFIGS.EMOJI.cycleTransition(currentTranscriptLines.transcriptStart);
                    }
                    SubtitleRender.applyEmojiTransition(context, time, duration, newTransition, others);
                }
                context.fillText(word.emojis, 0, 0);
                if(CONFIGS.EMOJI.DEBUG) {
                    context.save();
                    context.fillStyle = 'red';
                    context.strokeStyle = 'blue';
                    
                    // draw emoji box rect
                    context.rect(
                        emojiRect.x,
                        emojiRect.y,
                        emojiRect.width,
                        emojiRect.height
                    );
                    context.stroke();

                    // draw center of emoji
                    context.beginPath();
                    const center = others.emojiCenter;
                    const radius = 10;
                    context.arc(center.x, center.y, radius, 0, 2 * Math.PI);
                    context.fill();

                    context.restore();
                }
                currentEmojiOffsetX += measureEmojiPlusSpace.width;
                context.restore();
            }
            context.save();

            context.translate(xPosition, yPosition + word.height); // + word.height as text is drawn from bottom and not top
            // // wordHighlight: 'current-only' | 'upto-current' | 'background' | 'none';
            let textColor = secondaryColor;
            let textStrokeColor = outlineColor;
            switch (subtitleConfig.wordHighlight) {
                case 'current-only':
                    if (isHighlighted) {
                        textColor = primaryColor;
                    }
                    break;
                case 'upto-current':
                    // if (isLaterThanHighlighted) {
                    //     context.globalAlpha = .5;
                    // }
                    if (isBeforeHighlighted || isHighlighted) {
                        textColor = primaryColor;
                    }
                    break;
                case 'background':
                    textColor = secondaryColor;
                    break;
                case 'none':
                    break;
            }
            if (isHighlighted) {
                const time = playerConfig.currentTime - word.start;
                if (subtitleConfig.transition === 'word-slideup') {
                    const totalDuration = CONFIGS.WORD_SLIDEUP.TIME_DURATION;
                    const maxOffset = CONFIGS.WORD_SLIDEUP.MAX_OFFSET;
                    const minOffset = 0;
                    const offset = MathUtil.lerp(maxOffset, minOffset, time / totalDuration, 'ease-out');
                    context.translate(0, offset);
                } else if (subtitleConfig.transition === 'word-bounce') {
                    const totalDuration = CONFIGS.WORD_BOUNCE.TIME_DURATION;
                    const maxScale = CONFIGS.WORD_BOUNCE.MAX_SCALE;
                    const minScale = CONFIGS.WORD_BOUNCE.MIN_SCALE;
                    const scale = MathUtil.lerp(minScale, maxScale, time / totalDuration, 'bounce');
                    context.translate(word.width / 2, 0);
                    context.textAlign = 'center';
                    context.scale(scale, scale);
                }
            }

            if (isLaterThanHighlighted && subtitleConfig.enableWordReveal) {
                context.globalAlpha = 0;
            }
            if (subtitleConfig.wordHighlight === 'background' && isHighlighted) {
                const xPadding = CONFIGS.WORD_BOX.PADDING;
                const yPadding = CONFIGS.WORD_BOX.PADDING;
                const radius = CONFIGS.WORD_BOX.RADIUS;
                context.save();
                context.fillStyle = primaryColor;
                context.translate(0, +word.heightBelowBaseline);
                if (subtitleConfig.transition === 'word-bounce') {
                    context.translate(-word.width / 2, 0);
                }
                context.beginPath();
                context.roundRect(
                    -xPadding,
                    +yPadding, // fix height currently is using line height
                    word.width + xPadding * 2,
                    -word.height - yPadding * 2,
                    radius
                );

                context.fill();
                context.restore();
            }
            context.fillStyle = textColor;
            if (subtitleConfig.font.fontStrokeSize !== 0) {
                context.strokeStyle = textStrokeColor;
                context.strokeText(text, 0, 0);
            }
            context.fillText(text, 0, 0);
            context.restore();
        }
    }

    static applyEmojiTransition(context, time, duration, transition, others) {
        switch (transition) {
            case 'slide-up': {
                const startOffset = others.allEmojisHeight;
                const endOffset = 0;
                const offset = MathUtil.lerp(startOffset, endOffset, time / duration, 'ease-out');
                context.translate(0, offset);
                const opacity = MathUtil.lerp(0, 1, time / duration, 'ease-out');
                context.globalAlpha = opacity;
                break;
            }
            case 'slide-down': {
                const startOffset = -others.allEmojisHeight;
                const endOffset = 0;
                const offset = MathUtil.lerp(startOffset, endOffset, time / duration, 'ease-out');
                context.translate(0, offset);
                const opacity = MathUtil.lerp(0, 1, time / duration, 'ease-out');
                context.globalAlpha = opacity;
                break;
            }
            case 'scale-in': {
                const maxScale = 1;
                const minScale = 0;
                const scale = MathUtil.lerp(minScale, maxScale, time / duration, 'ease-out');
                context.translate(others.emojiCenter.x, others.emojiCenter.y);
                context.scale(scale, scale);
                context.translate(-others.emojiCenter.x, -others.emojiCenter.y);
                const opacity = MathUtil.lerp(0, 1, time / duration, 'ease-out');
                context.globalAlpha = opacity;
                break;
            }
            case 'rotate': {
                const maxRotate = MathUtil.toRadians(CONFIGS.EMOJI.ROTATE_MAX_DEGREE);
                const minRotate = 0;
                const rotate = MathUtil.lerp(minRotate, maxRotate, time / duration, 'sine-time');
                const opacity = MathUtil.lerp(0, 1, time / duration, 'ease-out');
                context.translate(others.emojiCenter.x, others.emojiCenter.y);
                context.rotate(rotate);
                context.translate(-others.emojiCenter.x, -others.emojiCenter.y);
                context.globalAlpha = opacity;
                break;
            }
            case 'scale-in-rotate': {
                SubtitleRender.applyEmojiTransition(context, time, duration, 'scale-in', others);
                SubtitleRender.applyEmojiTransition(context, time, duration, 'rotate', others);
                break;
            }
            case 'fade-in': {
                const opacity = MathUtil.lerp(0, 1, time / duration, 'ease-out');
                context.globalAlpha = opacity;
                break;
            }
            default:
                break;
        }
    }

    static getLineWidth(transcriptWordsLine, lineIndex) {
        const wordsAtLine = transcriptWordsLine.filter((word) => word.lineIndex === lineIndex);
        const lineStart = wordsAtLine[0].x;
        const lineEnd = wordsAtLine[wordsAtLine.length - 1].x + wordsAtLine[wordsAtLine.length - 1].width;
        return lineEnd - lineStart;
    }
    // static DebugAlignment(playerConfig) {
    //     const { blockPositionPaddingFactorTop, blockPositionPaddingFactorBottom, context } = playerConfig;
    //     context.save();
    //     context.strokeStyle = 'yellow'
    //     context.lineWidth = 2;
    //     // draw horizontal center line
    //     context.beginPath();
    //     context.moveTo(0, playerConfig.canvasHeight / 2);
    //     context.lineTo(playerConfig.canvasWidth, playerConfig.canvasHeight / 2);
    //     // draw padding top
    //     context.moveTo(0, playerConfig.canvasHeight * blockPositionPaddingFactorTop);
    //     context.lineTo(playerConfig.canvasWidth, playerConfig.canvasHeight * blockPositionPaddingFactorTop);
    //     // draw padding bottom
    //     context.moveTo(0, playerConfig.canvasHeight - playerConfig.canvasHeight * blockPositionPaddingFactorBottom);
    //     context.lineTo(playerConfig.canvasWidth, playerConfig.canvasHeight - playerConfig.canvasHeight * blockPositionPaddingFactorBottom);

    //     // draw vertical center line
    //     context.moveTo(playerConfig.canvasWidth / 2, 0);
    //     context.lineTo(playerConfig.canvasWidth / 2, playerConfig.canvasHeight);

    //     context.stroke();


    //     // draw max width box 
    //     context.strokeRect((playerConfig.canvasWidth - playerConfig.maxWidth) / 2, 0, playerConfig.maxWidth, playerConfig.canvasHeight);



    //     context.restore();
    // }
}

class MathUtil {
    static toRadians(deg) {
        return deg * Math.PI / 180
    }
    static clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }
    static lerp(start, end, t, mode) {
        t = MathUtil.clamp(t, 0, 1);
        if (mode === 'linear') {
            return start + (end - start) * t;
        } else if (mode === "bounce") {
            return start + (end - start) * MathUtil.easeOutBack(t);
        } else if (mode === "ease-in") {
            return start + (end - start) * t * t;
        } else if (mode === "ease-out") {
            return start + (end - start) * (1 - Math.pow(1 - t, 3));
        } else if (mode === "sine-time") {
            const sineT = Math.sin(t * MathUtil.toRadians(360));
            return start + (end - start) * sineT;
        } else {
            return start + (end - start) * t;
        }
    }
    static easeOutBack(x) {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }
}